import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    fontFamily: 'TWKLausanne',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  payButtonView: {
    borderRadius: 6,
    overflow: 'hidden',
  },

  payButton: {
    height: 42,
    width: 272,
    borderRadius: 6,
    backgroundColor: colors.primary,
    color: colors.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  payButtonLabel: {
    fontSize: 14,
    fontWeight: 450,
    textDecoration: 'none',
    color: colors.white,
  },

  payButtonDisabled: {
    height: 42,
    width: 272,
    backgroundColor: colors.primary,
    color: colors.white,
    borderRadius: 6,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0.5,
  },
});
